export default __webpack_public_path__ + "static/media/western15.2f023694.jpeg";